import { render, staticRenderFns } from "./PlayerStatus.vue?vue&type=template&id=23abf470&scoped=true"
import script from "./PlayerStatus.vue?vue&type=script&lang=js"
export * from "./PlayerStatus.vue?vue&type=script&lang=js"
import style0 from "./PlayerStatus.vue?vue&type=style&index=0&id=23abf470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abf470",
  null
  
)

export default component.exports